// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"4a9ead59","97":"5a7cf647","110":"057cdc50","453":"92d1349f","535":"a6bbe6f7","660":"c32f947e","745":"601c62df"}[chunkId] + ".chunk.js";
};